// import lang from './lang'
//
function convert(el, binding) {
    return el, binding

}
//
const l2c = {
    inserted: (el, binding) => convert(el, binding),
    update: (el, binding) => convert(el, binding)
}
export default l2c